<app-base-action-modal
  modalTitle="View Upcoming Payments"
  primaryLabel="Close"
  i18n-modalTitle
  i18n-primaryLabel
  [hideSecondary]="true"
  (closeClicked)="close()"
  (primaryClicked)="close()">
  <div class="upcoming-payments-container">
    <div class="modal-subtext" i18n>
      The next 5 payments, as of the current configuration, are outlined below. Note that lump sum payment dates are
      approximate.
    </div>
    <div class="d-flex flex-column gap-3">
      <ng-container *ngFor="let payment of upcomingPayments; trackBy: trackByIndex; let last = last">
        <div class="payment" [class.bottom-border]="!last">
          <div class="d-flex flex-column gap-2">
            <div class="fw-semibold">{{ payment.paymentType }}</div>
            <div>{{ payment.date | date : payment.dateFormat }}</div>
          </div>
          <div class="fw-semibold">{{ payment.amount | currency }}</div>
        </div>
      </ng-container>
    </div>
  </div>
</app-base-action-modal>
